import data from "../../.sourceflow/consultants.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class ConsultantsCollectionHelper extends CollectionHelper {
  fetch({
    limit = null,
    featured = null,
    specialty = null,
    sector = null,
    employer = null,
    branch = null,
    exclude = null,
    filter = null,
  } = {}) {
    let items = this.collection.getItems();

    if (filter) {
      items = items.filter(filter);
    }

    if (specialty) {
      if (Array.isArray(specialty)) {
        items = items.filter((i) => specialty.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        if(specialty) {
          items = items.filter((i) => {
            if (i.specialisms) {
              return JSON.stringify(i.specialisms).toUpperCase().includes(specialty.toUpperCase())
            } else {
              return false;
            }
          });
        }
      }
    }

    if (sector) {
      if (Array.isArray(sector)) {
        items = items.filter((i) => sector.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(sector));
      }
    }

    if (employer) {
      items = items.filter((i) => JSON.stringify(i.categories).includes(employer));
    }

    if (branch) {
      items = items.filter((i) => JSON.stringify(i.categories).includes(branch));
    }

    if (featured) {
      items = items.filter((i) => i.featured === featured);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    return items;
  }
}

export const consultant_helper = new ConsultantsCollectionHelper(data);
